import { render, staticRenderFns } from "./addSection.vue?vue&type=template&id=349154ff&scoped=true"
import script from "./addSection.vue?vue&type=script&lang=js"
export * from "./addSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349154ff",
  null
  
)

export default component.exports